import './Notify.scss';

class Notify {

    static success(text) {
        this.render(text, 'success');
    }

    static error(text) {
        this.render(text, 'error')
    }

    static render(text, status) {
        let modal = document.createElement('div');
        modal.textContent = text;
        modal.classList.add('notify');

        switch (status) {
            case 'error':
                modal.classList.add('notify--error');
        }

        document.body.append(modal);
        setTimeout(() => {modal.remove()}, 2000);
    }
}
export default Notify;